import { Component } from '@angular/core';

@Component({
  templateUrl: './minimal-layout.component.html',
  styleUrls: ['./minimal-layout.component.scss'],
})
export class MinimalLayoutComponent {}
